<template>
    <v-flex>
        <v-layout column>
            <v-flex pa-2>
                <v-flex  xs12>                
                    <v-layout row >
                        <v-text-field
                        label="Zoek asset"
                        @keyup.native="keyHit"                    
                        v-model="searchText"
                        outline
                        ></v-text-field>       
                        <v-btn @click="search()" color="accent"><i class="fal fa-search fa-2x"></i></v-btn>                             
                    </v-layout>
                    <v-data-table  
                        v-if="searchedAssets"                          
                        no-data-text="Geen zoek resultaat"
                        :headers="gridHeaderComp"
                        :items="searchedAssets" 
                        hide-actions>
                        <template slot="items" slot-scope="assets">
                            <tr @click="selectAsset(assets.item)" style="cursor:pointer;">                            
                                <td style="text-align:left;"> <i :class="icon(assets.item)"></i> </td>
                                <td style="text-align:left;">{{assets.item.name}}</td>
                                <td style="text-align:left;">{{group(assets.item)}}</td>
                                <td v-if="type=='favorite_search'" style="text-align:left;">{{isFavorite(assets.item) ? "Ja" : "Nee"}}</td>
                            </tr>                        
                        </template>
                    </v-data-table>
                    <v-flex xs12 v-if="assetSearchMeta && assetSearchMeta.pagination && assetSearchMeta.pagination.total_pages > 1" d-flex pt-2>
                        <v-pagination              
                            v-model="page"
                            :length="assetSearchMeta.pagination.total_pages"                           
                            @input="search()">
                        </v-pagination>
                    </v-flex>                                            
                </v-flex>
            </v-flex>
        </v-layout>
    </v-flex>
</template>

<script>
  import Vue from 'vue'
  import { mapGetters } from 'vuex'
  import * as types from "../../store/types"  
    export default {
        data() {
            return {
                searchText: "",
                lastSearch:"",
                page:1,
                gridHeaders: [
                    { text: "", sortable: false },
                    { text: "Assetnaam", sortable: false },
                    { text: "Groep", sortable: false }                                                   
                ]                
            }
        },
        props: {
            type: {            
                type: String,
                default:"default"                
            },            
            includeFavoritesUserId:{
                default:null
            },
        },
        computed: {
            ...mapGetters({ 
                searchedAssets:types.ASSETS_SEARCH,    
                assetSearchMeta:types.ASSETS_SEARCH_META     
            }),
            gridHeaderComp(){
                let headers = this.gridHeaders
                
                if(this.type=="favorite_search"){
                    headers.push({text:"is favoriet", sortable:false})                    
                }   
                return headers         
            },
            includes(){
                let includes = "type,group"

                if(this.type=="favorite_search"){
                    includes += ",userFavorites"
                }
                return includes
            }

        },
        methods: {
            icon(item){
                return (item.group && item.group.icon) ? item.group.icon : ""
            },
            group(item){
                return (item.group) ? item.group.name : "onbekend"
            },            
            search(){        
                if(this.searchText.length > 2){

                    if(this.lastSearch != this.searchText){
                        this.page=1
                    }
                    // for now includeFavoritesUserId is not used on backend since it does not help influencing the search result 
                    this.$store.dispatch(types.ASSETS_SEARCH, {data: {searchTerm: this.searchText}, params: {include: this.includes,includeFavoritesUserId:this.includeFavoritesUserId, per_page: 5, page:this.page}}).then(() => {
                        this.lastSearch = this.searchText
                    })                
                }
                else{
                    this.$notify('Uw zoekterm dient minimaal 3 karakters lang te zijn', {type: 'warning', icon: 'warning'})
                }
            },
            keyHit(e){     
                if(e.keyCode == 13){                                
                    this.search()
                }
            },
            isFavorite(asset){
                if(!asset.userFavorites || !this.includeFavoritesUserId){
                    return false
                }
                else{
                    let vm = this
                    let res =  asset.userFavorites.find((ele) => { return ele.userId == vm.includeFavoritesUserId }) 
                    return res ? true : false
                }            
            },
            selectAsset(asset){
                this.$emit("AssetSelected", asset)
            }
        },
        mounted(){
            console.log("meegegeven userid", this.includeFavoritesUserId);
        }
    }
</script>

<style lang="scss" scoped>

</style>